import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';

import { getGetAllConnectorsQueryOptions } from '@/api/gen';
import { ConnectorsSystemsPage } from '@/components/features/connectors/ConnectorsSystemsPage';

const connectorsSearchSchema = z.object({
  /** Connector id whose drawer is open (deep-linkable). */
  open: z.string().optional().catch(undefined),
  /** Active view; topology is the default and omitted from the URL. */
  tab: z.literal('grid').optional().catch(undefined),
  /** Connector domain expanded into its own orbit on the topology tab. */
  domain: z.string().optional().catch(undefined),
});

export type ConnectorsSearch = z.infer<typeof connectorsSearchSchema>;

export const Route = createFileRoute('/_protected/t/$tenantId/connectors/')({
  // The topology lays out from live container size — client-only, like the
  // other canvas routes (data-foundry, loom).
  ssr: false,
  validateSearch: connectorsSearchSchema,
  beforeLoad: async ({ context: { queryClient } }) => {
    await queryClient.prefetchQuery(getGetAllConnectorsQueryOptions());
  },
  component: ConnectorsSystemsPage,
});
